// Test IDs for card components

export const CARD_TEST_IDS = {
  PRICE: 'card-price',
  BADGE: 'card-badge',
  INFO_BTN: 'info-btn',
  TEXT: 'card-text',
  SUBTEXT: 'card-subtext',
  SUBTEXT_ADDITIONAL: 'card-subtext-additional',
} as const;

export const CARD_LIST_TEST_IDS = {
  ADVANCED_OPTIONS_BTN_MOBILE: 'advanced-options-btn-mobile',
  ADVANCED_OPTIONS_BTN_DESKTOP: 'advanced-options-btn-desktop',
  getRemoveBtnMobile: (section: string) => `remove-${section}-btn-mobile`,
  getRemoveBtnDesktop: (section: string) => `remove-${section}-btn-desktop`,
} as const;

export const CARD_LIST_BASE_STYLE_TEST_IDS = {
  CARD: 'base-style-card',
  DESCRIPTION: 'base-style-description',
} as const;

export const CARD_LIST_IN_STORE_TEST_IDS = {
  SCAN_CARD: 'scan-card',
} as const;

